import { gql } from "@apollo/client";
import { ContaminationDeclarationFields } from "../fragments/contaminationDeclaration";

// Partial save: omitted keys are left untouched, so callers send only the
// answers the user changed (see utils/contaminationDeclaration/buildUpdateInput).
export const UpdateContaminationDeclaration = gql`
    mutation UpdateContaminationDeclaration (
        $id: ID!,
        $input: ContaminationDeclarationUpdateAttributesInput!
    ) {
        updateContaminationDeclaration (contaminationDeclarationId: $id, input: $input) {
            ...ContaminationDeclarationFields
        }
    }
    ${ContaminationDeclarationFields}
`;
